import React from 'react';
import styles from './Spacer.module.css';

const Spacer = props => (
    <div className={ styles.Spacer }></div>
);

export default Spacer;